// src/components/Navbar.js
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  // ✅ put handleLogout here
  const handleLogout = () => {
    localStorage.removeItem("userId");
    localStorage.removeItem("name");
    navigate("/");   // back to login
  };

  // Interviewee pages → brand centered only
  if (location.pathname.startsWith("/interviewee")) {
    return (
      <header>
        <div className="navbar" style={{justifyContent:"center"}}>
          <div className="brand">InterviewAI</div>
        </div>
      </header>
    );
  }

  return (
    <header>
      <div className="navbar">
        <div className="brand">InterviewAI</div>
        <div className="nav-actions">
          {!userId && location.pathname === "/" && <Link to="/signup" className="nav-link">Sign up</Link>}
          {!userId && location.pathname === "/signup" && <Link to="/" className="nav-link">Sign in</Link>}
          {userId && (location.pathname.startsWith("/interviews") || location.pathname.startsWith("/sessions")) && (
            <div className="nav-actions">
                <Link to={`/dashboard/${userId}`} className="nav-link">Dashboard</Link>
                <span className="nav-link logout" onClick={handleLogout}>Sign out</span>
            </div>
            )}

           {userId && location.pathname.startsWith("/dashboard") && (
            <div className="nav-actions">
                <span className="nav-link logout" onClick={handleLogout}>Sign out</span>
            </div>
            )}

        </div>
      </div>
    </header>
  );
}
